import React, { useState } from 'react'
import { makeStyles, Theme } from '@material-ui/core/styles'
import { FormattedMessage, useIntl } from 'react-intl'
import messages from '../../../messages'
import {
  Grid,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from '@material-ui/core'
import { Field, Formik } from 'formik'
import LiquidInputAdapter from '@src/components/LiquidInputAdapter'
import ValidationErrors from '@src/routes/Configurators/validations/ValidationErrors'
import { validateText, convertToASCII } from '../../../utils/util'
import globalStyles from '@src/routes/Configurators/utils/styles'
import clsx from 'clsx'

const useStyles = makeStyles((theme: Theme) => {
  return {
    root: {
      fontFamily: 'Lato',
    },
    dialogPaper: {
      width: theme.spacing(127.5),
      margin: theme.spacing(0),
      borderRadius: 0,
    },
    dialogTitle: {
      padding: theme.spacing(8),
    },
    title: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      fontWeight: theme.typography.fontWeightBold,
      textTransform: 'uppercase',
      lineHeight: 1.2,
      letterSpacing: '1px',
    },
    content: {
      padding: theme.spacing(0, 8),
      overflowY: 'unset',
    },
    actions: {
      padding: theme.spacing(2, 8, 8, 0),
      marginTop: theme.spacing(8),
    },
    actionButton: {
      fontSize: theme.typography.pxToRem(16),
    },
    oligoLabel: {
      '& label': {
        fontSize: theme.typography.pxToRem(14),
        fontWeight: theme.typography.fontWeightBold,
      },
    },
    helpText: {
      fontSize: theme.typography.pxToRem(12),
      marginBottom: theme.spacing(1),
    },
    validateError: {
      marginLeft: theme.spacing(-4),
      marginTop: theme.spacing(-4),
      '&.Mui-error.Mui-focused': {
        border: '0 none',
        borderBottom: `1px solid ${theme.palette.error.main}`,
      },
      paddingLeft: theme.spacing(4),
      paddingTop: theme.spacing(2),
      paddingRight: theme.spacing(10),
    },
  }
})
export interface EditConcentrationProps {
  dialogOpen: boolean
  setDialogOpen: React.Dispatch<React.SetStateAction<boolean>>
  selectedConcentration: any
  UpdateNewConcentration: any
}

const EditConcentration: React.FC<EditConcentrationProps> = (props) => {
  const classes = useStyles()
  const intl = useIntl()
  const globalClasses = globalStyles()
  const {
    dialogOpen,
    setDialogOpen,
    selectedConcentration,
    UpdateNewConcentration,
  } = props
  let [splChar] = useState<string>('')

  const [concentration, setConcentartion] = useState<string | null | undefined>(
    selectedConcentration
  )
  const [nameValidationErrors, setNameValidationErrors] = useState<string[]>([])
  const checkSpecialChar = (value): string => {
    splChar = ''
    value !== undefined &&
      value.split('').forEach((c) => {
        if (!c.match(/^[0-9.]*$/) && !splChar.includes(c)) {
          if (splChar === '') {
            splChar = c
          } else {
            splChar = splChar + ', ' + c
          }
        }
      })
    return splChar
  }

  const amountValue = (value) => {
    const index = value.indexOf('.')
    if (index !== -1) {
      value = value.slice(0, index + 2)
    }
    return value
  }

  const handleOnChange = (event) => {
    const { value } = event.target
    const concentration = validateText(convertToASCII(value))
    let val = ''
    val = checkSpecialChar(concentration)
    if (
      !(val !== null && val !== '' && val.length !== 0) &&
      concentration.length === amountValue(concentration).length
    ) {
      setConcentartion(amountValue(concentration))
      setNameValidationErrors([])
    }
  }

  const handleSave = () => {
    const errors: string[] = []
    if (concentration?.trim && concentration?.length !== 0) {
      if (
        concentration.endsWith('.') ||
        Number(concentration) === 0 ||
        Number(concentration) > 1000
      ) {
        errors.push(
          intl.formatMessage(messages.CONF_DNAPLATES_ERROR_CONCENTRATION)
        )
      } else {
        setDialogOpen(false)
        UpdateNewConcentration(concentration?.trim())
      }
    } else {
      errors.push(intl.formatMessage(messages.CONF_REQUIRED_FIELD))
    }
    setNameValidationErrors(errors)
  }

  return (
    <div className={classes.root}>
      <Dialog open={dialogOpen} classes={{ paper: classes.dialogPaper }}>
        <DialogTitle className={classes.dialogTitle}>
          <div className={classes.title}>
            <FormattedMessage
              {...messages.CONF_NGSO_GOLD_CONCENTRATION_POPUP_TITLE}
            />
          </div>
        </DialogTitle>
        <DialogContent className={classes.content}>
          <Formik
            initialValues={{}}
            validateOnChange={false}
            onSubmit={(values, actions) => {
              setTimeout(() => {
                actions.setSubmitting(false)
              }, 1000)
            }}
          >
            {() => (
              <>
                <Grid container>
                  <Grid item sm={11}>
                    <div>
                      <Field
                        name="concentration"
                        component={LiquidInputAdapter}
                        rootClass={classes.oligoLabel}
                        label={intl.formatMessage(
                          messages.CONF_NGSO_GOLD_CONCENTRATION_FIELD_HEADING
                        )}
                        filled
                        value={concentration}
                        onChange={handleOnChange}
                      />
                    </div>
                    <div
                      className={clsx(
                        classes.helpText,
                        globalClasses.globalHelpTextColor
                      )}
                    >
                      <FormattedMessage
                        {...messages.CONF_NGSO_GOLD_CONCENTRATION_FIELD_HELP_TEXT}
                      />
                    </div>
                    <div className={classes.validateError}>
                      <ValidationErrors errors={nameValidationErrors} />
                    </div>
                  </Grid>
                </Grid>
              </>
            )}
          </Formik>
        </DialogContent>

        <DialogActions className={classes.actions}>
          <Button
            color="primary"
            variant="contained"
            onClick={handleSave}
            className={classes.actionButton}
          >
            <FormattedMessage {...messages.SUBMIT} />
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  )
}
export default EditConcentration
